import { useRouter } from 'next/router';
import { EditingHelpText } from 'components/helpers/Editing/EditingHelpText';
import OneTrustFilter from 'components/helpers/OneTrust/OneTrustFilter';
import styles from './PearCommerceProduct.module.scss';

export type PearCommerceProductVariant = 'Retailer-List' | 'Product-Locator';

type PearCommerceProductProps = {
  variant?: PearCommerceProductVariant;
};

export function PearCommerceProduct({ variant = 'Product-Locator' }: PearCommerceProductProps) {
  const router = useRouter();
  const isProductLocator = variant === 'Product-Locator';
  const ariaLabel = variant === 'Product-Locator' ? 'Find product locations' : 'Shop products';
  const targetId = isProductLocator ? 'pear-map-target' : 'pear-pdp-target';
  const widgetContainerClassName = isProductLocator
    ? styles.productLocatorWidgetContainer
    : styles.pearWidgetContainer;

  return (
    <>
      <EditingHelpText>
        {isProductLocator
          ? 'Verify this page URL/path is configured in Pear Commerce, then test location search with valid and invalid city/state/ZIP values.'
          : 'Verify this page URL/path is configured in Pear Commerce so the Retailer List widget can load.'}
      </EditingHelpText>
      <OneTrustFilter
        filteredComponent={
          // Keyed on locale so switching locale (e.g. via the language switcher) destroys the
          // previous widget's DOM instead of leaving it behind when Pear's script re-injects,
          // which was causing two widgets to render on the same page.
          <div
            key={router.locale}
            id={targetId}
            className={widgetContainerClassName}
            role="region"
            aria-label={ariaLabel}
          />
        }
        placeholderFeatureType={isProductLocator ? 'productlocator' : 'retailerlist'}
        optanonGroups={['4']}
        enablePlaceholder={true}
      />
    </>
  );
}
